import { render, staticRenderFns } from "./CRMASRating.vue?vue&type=template&id=8e9893e8&scoped=true&"
import script from "./CRMASRating.vue?vue&type=script&lang=js&"
export * from "./CRMASRating.vue?vue&type=script&lang=js&"
import style0 from "./CRMASRating.vue?vue&type=style&index=0&id=8e9893e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9893e8",
  null
  
)

export default component.exports